import type { AxiosResponse } from 'axios'
import api from '../utils/api'
import { type EmailDeliveryEventListParams, type IEmailDeliveryEventListResponse, type IEmailDeliveryEventResponse } from '../models/EmailDeliveryEvent'

const normalizeSortParams = (sort?: string): Pick<EmailDeliveryEventListParams, 'sortBy' | 'sortOrder'> => {
  if (sort == null || sort.trim() === '') {
    return {}
  }

  try {
    const parsedSort = JSON.parse(sort) as Array<{ field?: string, direction?: 'asc' | 'desc' }>
    const firstSort = parsedSort?.[0]

    if (!firstSort?.field) {
      return {}
    }

    return {
      sortBy: firstSort.field,
      sortOrder: firstSort.direction ?? 'asc'
    }
  } catch {
    return {}
  }
}

const getEmailDeliveryEvents = async (params?: EmailDeliveryEventListParams): Promise<AxiosResponse<IEmailDeliveryEventListResponse>> => {
  const sortParams = normalizeSortParams(params?.sort)

  return await api.get('/api/email_delivery_events/', {
    headers: {
      Accept: 'application/cdg'
    },
    params: {
      // Follow the established table pattern in this repo.
      // Keep email pagination on pageSize/pageNumber unless explicitly approved otherwise.
      search: params?.search,
      pageSize: params?.pageSize,
      pageNumber: params?.pageNumber,
      ...sortParams
    }
  })
}

const getEmailDeliveryEventById = async (emailSentId: string): Promise<AxiosResponse<IEmailDeliveryEventResponse>> => {
  return await api.get(`/api/email_delivery_events/${emailSentId}/`)
}

export default {
  getEmailDeliveryEvents,
  getEmailDeliveryEventById
}
